$(document).ready(function() {
  $('.cart-item-increase, .cart-item-decrease').on('click', function(){
    setTimeout(function(){
      //Bold: Check for Bundle eligibility
      //$('[name="update"]').trigger("click");
      $('[name="checkout"]').attr('disabled', true);
    },200);
  });
  
  $('[name*="updates"]').on('change', function(){
    setTimeout(function(){
      //Bold: Check for Bundle eligibility
      //$('[name="update"]').trigger("click");
      $('[name="checkout"]').attr('disabled', true);
    },200);
  });
}); 